








































































import Vue from 'vue';
import DefaultWorkflowQueue from '@/components/workflow/DefaultWorkflowQueue.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreGroupedTable from '@/components/shared/Table/MStoreGroupedTable.vue';
import { DocuSignWorkflowJobService } from '@/services';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation } from '@/mixins';
import { DocuSignConstants, DocuSignGroupActionModel, DocuSignStandardProcessingAction } from '@/types';
import { BvTableFieldArray } from 'bootstrap-vue';
export default Vue.extend({
  name: 'DocuSignWorkflowQueue',
  mixins: [DefaultWorkflowQueue, FormFieldValidation],
  props: {
    workflowQueueDataModel: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      postIsLoading: false,
      docuSignGroupActionModel: {},
      isVoidEnvelope: false,
      modalTitle: 'Are you sure?'
    };
  },
  computed: {
    docuSignQueConfigurations(this: any) {
      return this.workflowQueueDataModel.additionalConfigurations;
    },
    docuSignButtons(this: any) {
      return this.docuSignQueConfigurations.docuSignButtons?.filter((x: any) => x.isConfigured);
    },
    queueColumns() {
      return [...this.workflowQueueDataModel.queueColumns] as BvTableFieldArray;
    }
  },
  methods: {
    async onButtonClicked(this: any, event: any, jobs: any[]) {
      this.docuSignGroupActionModel = {
        processingAction: event.processingAction,
        jobIds: jobs.map((x: any) => x.jobid)
      } as DocuSignGroupActionModel;

      if (event.processingAction === DocuSignStandardProcessingAction.VoidEnvelope) {
        this.postIsLoading = true;
        this.isVoidEnvelope = true;
      } else {
        const hasSignerDetails = jobs.every((job: any) => job.valid);
        if (!hasSignerDetails && event.processingAction === DocuSignStandardProcessingAction.CreateEnvelope) {
          const jobsWithOutSigners = jobs
            .filter((job: any) => !job.valid)
            .map((job: any) => job.jobid)
            .join(', ');

          this.$bvModal.msgBoxOk(`The envelope is missing some signer details. Please update signer details for ${jobs.length > 1 ? 'Jobs:' : 'Job:'} ${jobsWithOutSigners}`, {
            title: 'Validation Error',
            okVariant: 'warning',
            noCloseOnEsc: true,
            noCloseOnBackdrop: true
          });
          return;
        }
        const confirmationMessage = this.getConfirmationMessage(event, jobs);
        const userConfirmation = await this.$bvModal.msgBoxConfirm(confirmationMessage, {
          id: 'docuSignConfirmationModal',
          title: this.modalTitle,
          cancelVariant: 'danger',
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        });
        if (userConfirmation) {
          this.GroupActions(this.docuSignGroupActionModel);
        }
      }
    },
    onVoidReasonSubmit(this: any, event: any) {
      this.isVoidEnvelope = false;
      this.GroupActions(this.docuSignGroupActionModel);
    },
    onCloseVoidReasonModal(this: any) {
      this.isVoidEnvelope = false;
      this.postIsLoading = false;
      this.docuSignGroupActionModel = {};
    },
    async GroupActions(this: any, data: DocuSignGroupActionModel) {
      this.postIsLoading = true;
      try {
        await DocuSignWorkflowJobService.GroupActionsAsync(this.workflowQueueDataModel.queueId, data);
        SnotifyConfiguration.showSuccess(DocuSignConstants.SuccessMessage[data.processingAction!]);
      } catch (exception) {
        this.$log(exception);
      } finally {
        this.onCloseVoidReasonModal();
        this.getWorkflowQueue();
      }
    },
    getConfirmationMessage(this: any, event: any, jobs: any[]): string {
      const groupReference = jobs[0][this.docuSignQueConfigurations.groupByField];
      const selectedDocuments = jobs.length;
      const reference = this.workflowQueueDataModel.queueColumns.find((x: any) => x.key === this.docuSignQueConfigurations.groupByField).label;
      switch (event.processingAction) {
        case DocuSignStandardProcessingAction.CreateEnvelope: {
          return `You are about to create an envelope for ${selectedDocuments} document${selectedDocuments > 1 ? 's ' : ' '}for ${reference} ${groupReference}.`;
        }
        case DocuSignStandardProcessingAction.Cancel: {
          const totalDocuments = this.getDocumentCountForStockNumber(groupReference);
          return `You are about to cancel ${selectedDocuments} of ${totalDocuments} document${totalDocuments > 1 ? 's ' : ' '}for ${reference} ${groupReference}.`;
        }
        default: {
          return `You are about to ${event.caption} ${groupReference}.`;
        }
      }
    },
    getDocumentCountForStockNumber(this: any, stockNumber: string): number {
      return this.workflowQueueDataModel.queueData.filter((x: any) => x[this.docuSignQueConfigurations.groupByField] === stockNumber).length;
    }
  },
  components: {
    MStoreGroupedTable,
    LoadingSpinner
  }
});
